import PendingPoints from 'components/Content/GameDetails/Tasks/Task/PendingPoints/PendingPoints';
import { withPendingPointsProps } from 'viewModel/content/gameDetails/tasks/task/pendingPoints/withPendingPointsProps';

export default withPendingPointsProps(PendingPoints);
